<script context="module">
    import Layout from '@/Layouts/Main.svelte'
    export const layout = Layout
</script>

<script>
    import { inertia } from "@inertiajs/inertia-svelte";


    export let status;

    $: title = {
      503: '503: Service Unavailable',
      500: '500: Server Error',
      404: '404: Page Not Found',
      403: '403: Forbidden',
    }[status]

    $: description = {
      503: 'Sorry, we are doing some maintenance. Please check back soon.',
      500: 'Whoops, something went wrong on our servers.',
      404: 'Sorry, the page you are looking for could not be found.',
      403: 'Sorry, you are forbidden from accessing this page.',
    }[status]

</script>
<svelte:head>
  <title>Mur&amp;Partners | Error</title>
</svelte:head>



<div class="py-16">
    <div class="container mx-auto">
      <div class="w-96">
        <p class="text-xl">{title}</p>
        <p>{description}</p>
        <p><a href="/" class="text-blue" use:inertia>Home</a></p>
      </div>
    </div>
</div>
